import * as React from "react";
import { Outlet } from "react-router-dom";
import LoggedInNavigation from "./../components/Navigations/LoggedInNavigation";
import Footer from "../components/Footer";

function SubscriptionLayout({ backgroundColor = "#fff"}) {
	return (
		<div style={{backgroundColor}} className="d-flex flex-column min-vh-100">
			{/* Full site header (menu + guest hamburger), same as the home page.
			    Was EmptyNavigation (logo only), which left /pricing and
			    /work-with-chris without any header navigation. */}
			<LoggedInNavigation/>
			<div className="flex-grow-1">
				<Outlet/>
			</div>
			<Footer className="bg-dark-blue"/>
		</div>
	);
}

export default SubscriptionLayout;
